import { cn } from "@/components/ui/utils";
import { ABSENT_VALUE } from "@/lib/format";

interface MonoIdProps {
  children: React.ReactNode;
  className?: string;
}

/**
 * Renders document UIDs and short reference IDs with tabular numerals at xs size.
 * Consistent style for all UID/ref columns across ERP tables.
 * Falls back to "—" for any falsy value (null, undefined, empty string).
 */
export function MonoId({ children, className }: MonoIdProps) {
  const resolvedClassName = cn("min-w-0 truncate font-semibold text-sm tracking-tight", className);

  return (
    <span className={`${resolvedClassName} text-numeric`}>
      {children ? children : ABSENT_VALUE}
    </span>
  );
}
